/* eslint-disable camelcase */
import * as z from 'zod'

export const schema = z.object({
  odometer: z
    .string({ required_error: 'This field is required' })
    .min(1, { message: 'This field is required' })
    .refine(value => /^\d+$/.test(value), {
      message: 'Please enter a valid odometer reading',
    }),
})
